/**
 * Drop Sentry events originating from the local Vite dev server so they are not mixed into
 * the same project as deployed traffic (see FRONTEND-JQ noise from localhost).
 */

/** True when the URL host is loopback (typical Vite / local dev). */
export function isLoopbackHttpUrl(url: string): boolean {
  try {
    const { hostname } = new URL(url)
    return (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '[::1]' ||
      hostname === '::1'
    )
  } catch {
    return false
  }
}

export function shouldDropSentryEventFromLocalDevPage(event: {
  request?: { url?: string }
  tags?: Record<string, unknown>
}): boolean {
  const urls = [event.request?.url, event.tags?.url].filter(
    (u): u is string => typeof u === 'string' && u.length > 0,
  )
  return urls.some(isLoopbackHttpUrl)
}
